module.exports = __webpack_public_path__ + "static/media/lock.f2d167ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/lock.svg
// module id = 968
// module chunks = 0